import {Delete, FormPost, GET, POST, PUT} from "../util";

const operationUrl = "api/receivable-operation/";
const inspectionUrl = "api/receivable-inspection/";
const installmentContractOperationUrl = "api/installment-contract-operation/";
const installmentContractInspectionUrl = "api/installment-contract-inspection/";
const commonReceivableUrl = "api/common/receivable/";

const url = {
    operation: {
        uploadPdf: `${operationUrl}upload-with-pdf`,
        uploadExcel: `${operationUrl}upload-with-xml-or-excel/:isDisclosed`,
        uploadDocuments: `${operationUrl}bulk-upload-invoice-documents`,
        submitReview: `${operationUrl}submit-for-review`,
        deleteOperation: `${operationUrl}delete`,
        resetOperation: `${operationUrl}reset`,
        bundle: `${operationUrl}bundle-receivables`,
        smartBundle: `${operationUrl}smart-bundle-receivables`,
        unbundle: `${operationUrl}unbundle-receivable`,
        saveItem: `${operationUrl}save`,
        saveAndSubmit: `${operationUrl}save-and-submit-for-review`,
        uploadInvoice: `${operationUrl}single-upload-invoice-doc`,
        uploadAdditionalDocument: `${operationUrl}upload-additional-document?type=:type`,
        linkWithProspectiveReceivable: `${operationUrl}prospective-receivables/link/:receivableId/:prospectiveReceivableId`,
    },
    installmentContractOperation: {
        uploadPdf: `${installmentContractOperationUrl}upload-with-pdf`,
        uploadContractDocForEdit: `${installmentContractOperationUrl}upload-contract-doc-for-edit`,
        saveContract: `${installmentContractOperationUrl}save-contract`,
        submitContract: `${installmentContractOperationUrl}:contractId/submit-contract`,
		deleteContract: `${installmentContractOperationUrl}:contractId/delete-contract`,
    },
    installmentContractInspection: {
        contractDetails: `${installmentContractInspectionUrl}:contractId/details`,
        suggestPricing: `${installmentContractInspectionUrl}suggest-pricing`,

    },
    inspection: {
        new: `${inspectionUrl}list-new`,
        waiting: `${inspectionUrl}list-waiting`,
        declined: `${inspectionUrl}list-declined`,
        counts: `${inspectionUrl}counts`,
        receivableDetail: `${commonReceivableUrl}details`,
        receivableDetailWithAutoFills: `${inspectionUrl}details-with-auto-fill`,
        availableDebtors: `${inspectionUrl}debtor/available`,
        contactList: `${inspectionUrl}debtor/`,
        documentList: `${inspectionUrl}documents/info/`,
        singleConfirmationData: `${inspectionUrl}confirmation-data/single`,
        multiConfirmationData: `${inspectionUrl}confirmation-data/multi`,
        suggestPricing: `${inspectionUrl}suggest-pricing`,
        uploadSettings: `${inspectionUrl}upload-settings`,
        listMatchingProspectiveReceivables: `${inspectionUrl}prospective-receivables/list/:debtorId`,
		checkInvoiceNumberAvailability: `${inspectionUrl}invoice-number-availability-check`,
    }
};

const receivableApi = {
    inspection: {
        counts: () => {
            return GET(url.inspection.counts);
        },
        listNew: (params = {}) => {
            return POST(url.inspection.new, params);
        },
        listWaiting: (params = {}) => {
            return POST(url.inspection.waiting, params);
        },
        listDeclined: (params = {}) => {
            return POST(url.inspection.declined, params);
        },
        loadSingleConfirmationData: (params = {}) => {
            return POST(url.inspection.singleConfirmationData, params);
        },
        loadMultiConfirmationData: (params = {}) => {
            return POST(url.inspection.multiConfirmationData, params, "application/json", 'Array');
        },
        suggestPricing(params) {
            return POST(url.inspection.suggestPricing, params);
        },
        getUploadSettings: (params = { forInstallment: false }) => {
            let realUrl = url.inspection.uploadSettings;
            if (params.forInstallment) {
                realUrl = realUrl + '?forInstallment=true';
            }
            return GET(realUrl, params);
        },
        listMatchingProspectiveReceivables: (params = {}) => {
            return GET(url.inspection.listMatchingProspectiveReceivables.replace(":debtorId", params));
        },
		checkInvoiceNumberAvailability: (params) => {
			return POST(url.inspection.checkInvoiceNumberAvailability, params);
		}
    },
    uploadDocuments: (params = {}) => {
        return FormPost(url.operation.uploadDocuments, params);
    },
    uploadAdditionalDocument: (fileType, params = {}) => {
        return FormPost(url.operation.uploadAdditionalDocument.replace(":type", fileType), params);
    },
    uploadPdf: (params = {}) => {
        return FormPost(url.operation.uploadPdf, params);
    },
    uploadExcel: (params = {}) => {
        let realUrl = url.operation.uploadExcel.replace(":isDisclosed", params.isDisclosed);
        return FormPost(realUrl, params);
    },
    submitReview: (params = {}) => {
        return POST(url.operation.submitReview, params, "application/json", 'Array');
    },
    deleteOperation: (params = {}) => {
        return Delete(url.operation.deleteOperation, params, "application/json", 'Array');
    },
    receivableDetail: (id) => {
        return GET(url.inspection.receivableDetail + '/' + id, {}, false);
    },
    receivableDetailWithAutoFills: (id) => {
        return GET(url.inspection.receivableDetailWithAutoFills + '/' + id, {}, false);
    },
    resetOperation: (params = {}) => {
        return POST(url.operation.resetOperation, params, "application/json", 'Array');
    },
    bundle: (params = {}) => {
        return POST(url.operation.bundle, params, "application/json", 'Array');
    },
    smartBundle: () => {
        return POST(url.operation.smartBundle);
    },
    unbundle: (id) => {
        return POST(url.operation.unbundle + '/' + id);
    },
    availableDebtors: () => {
        return GET(url.inspection.availableDebtors);
    },
    debtorContact: (id) => {
        return GET(url.inspection.contactList + id + '/list-favorites', );
    },
    saveItem: (params = {}) => {
        return POST(url.operation.saveItem, params);
    },
    saveAndSubmit: (params = {}) => {
        return POST(url.operation.saveAndSubmit, params);
    },
    uploadInvoice: (id, params) => {
        return FormPost(url.operation.uploadInvoice + '/' + id, params);
    },
    allReceivableDocuments: (token, purpose) => {
        return GET(url.inspection.documentList + "?token=" + token + " &purpose=" + purpose);
    },
    linkWithProspectiveReceivable: (params) => {
        return POST(url.operation.linkWithProspectiveReceivable
            .replace(":receivableId", params.receivableId)
            .replace(":prospectiveReceivableId", params.prospectiveReceivableId)
        );
    },
    installmentContractInspection: {
        getContractDetails: (contractId) => {
            return GET(url.installmentContractInspection.contractDetails.replace(":contractId", contractId));
        }
    },
    installmentContractOperation: {
        uploadPdf: (params = {}) => {
            return FormPost(url.installmentContractOperation.uploadPdf, params);
        },
        uploadContractDocForEdit: (params) => {
            return FormPost(url.installmentContractOperation.uploadContractDocForEdit, params);
        },
        saveContract(params = {}) {
            return POST(url.installmentContractOperation.saveContract, params);
        },
        submitContract(contractId = {}) {
        	return POST(url.installmentContractOperation.submitContract.replace(":contractId", contractId));
        },
		deleteContract(contractId) {
			return Delete(url.installmentContractOperation.deleteContract.replace(":contractId", contractId));
		}
    }
};
export {
    receivableApi
};